// extracted by mini-css-extract-plugin
module.exports = {"popupCorner":"HeaderBrowse_popupCorner__ssEsi","customPosition":"HeaderBrowse_customPosition__1MER7"};